import React from 'react';
import styled from 'styled-components';
import HorizontalArticleCard from '../article-card/horizontal';
import ArticleCard from '../article-card';
import { ListComponent } from '../builders/listing-builder';
import Pagination from '../pagination';
import { MobileSection } from '../shared/mobile-section';
import { DesktopSection } from '../shared/desktop-section';

const Desktop = styled(DesktopSection)`
  padding: 0;
`;

const Mobile = styled(MobileSection)`
  padding: 0;
`;

const NewsList: React.FC<ListComponent> = ({
  articles,
  totalPages,
  currentPage,
}) => (
  <>
    <Desktop>
      {articles.edges.map(({ node: { articleSettings: article } }) => (
        <HorizontalArticleCard
          key={article.slug}
          article={article}
        />
      ))}
    </Desktop>
    <Mobile>
      {articles.edges.map(({ node: { articleSettings: article } }) => (
        <ArticleCard
          key={article.slug}
          article={article}
        />
      ))}
    </Mobile>
    <Pagination
      totalPages={totalPages}
      currentPage={currentPage}
      subPath="news"
    />
  </>
);

export default NewsList;
